/**
 * useModalStore — Global modal management (no persistence).
 *
 * Methods: openModal(type, props), closeModal()
 * Types: TASK_MODAL, PROJECT_MODAL, PROJECT_RESOURCE_MODAL, PROPERTY_MANAGER_MODAL, FRICTION_MODAL
 */
import { create } from 'zustand';

export const MODAL_TYPES = {
    TASK_MODAL: 'TASK_MODAL',
    PROJECT_MODAL: 'PROJECT_MODAL',
    PROJECT_RESOURCE_MODAL: 'PROJECT_RESOURCE_MODAL',
    PROPERTY_MANAGER_MODAL: 'PROPERTY_MANAGER_MODAL',
    FRICTION_MODAL: 'FRICTION_MODAL',
};

const useModalStore = create((set) => ({
    activeModal: null,
    modalProps: {},

    openModal: (type, props = {}) => set({
        activeModal: type,
        modalProps: props
    }),

    closeModal: () => set({
        activeModal: null,
        modalProps: {}
    })
}));

export default useModalStore;
